import { useQuery } from "convex/react";
import { api } from "../convex/_generated/api.js";
import useStoreUserEffect from './useStoreUserEffect.js'
import './Profile.css'
import { useUser } from "@clerk/clerk-react"
import { DataGrid } from '@mui/x-data-grid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Profile = () => {

    const userId = useStoreUserEffect()
    const user = useQuery(api.users.getUser)
    const AppliedReferrals = useQuery(api.applicants.getAppliedReferrals,userId !== null ? { id: userId } : "skip")
    const PostedReferrals = useQuery(api.referrals.getReferralByUserId,userId !== null ? { id: userId } : "skip")
    console.log(user)
    const handleButtonClick = (id) => {
        window.location.href = "/applicants/"+id
    }
    
    
    const columns = [
        { field: 'Company', headerName: 'Company', width: 200 },
        { field: 'Created_On', headerName: 'Number of applicants', width: 200, renderCell: (params) => (
            <div className="progress">
                <div
                    className="progress-bar"
                    role="progressbar"
                    aria-valuenow={params.row.id}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
            </div>
        )},
        { field: 'View_applicants', headerName: 'View Applicants', width: 200, renderCell: (params) => (
            <button
              className="apply-radio"
              color="primary"
              onClick={() => handleButtonClick(params.row.id)}
            >
              View Applicants
            </button>
        )},
    ]
    const applicantcolumns = [
        { field: 'Company', headerName: 'Company', width: 200 },
        { field: 'Yoe', headerName:'Year of experience required', width:200}

    ]
    const rows = PostedReferrals ? PostedReferrals.map(posted_referral => ({
        id: posted_referral._id,
        Company: posted_referral.company,
        Created_On: posted_referral._creationTime,
        Number_of_applicants: posted_referral.numberOfApplicants*100/posted_referral.applicants.length,
        View_applicants: (<button>View applicants</button>)
    })) : null

    const applicantrows = AppliedReferrals ? AppliedReferrals.map(applied_referral => ({
        id: applied_referral._id,
        Company: applied_referral.company,
        Yoe: applied_referral.yoe
    })) : null
    
    
    const imageUrl = useUser().user.imageUrl;
    if(user == null){
    return (
     <div>Loading</div> 
    )
    }
    return (
        <div className="body">
        <div className="profile-sidebar">
            <div className="profile-image">
                <img src={imageUrl} alt="profile-image" />
            </div>
            <div>{user.name}</div>
            &nbsp;
            <FontAwesomeIcon icon={faEnvelope} />
            <span>{user.email}</span>
        </div>
        <div className="profile-content">
        <div className="Card">
            <p>Applied Referrals </p>
            {AppliedReferrals &&  <DataGrid
            rows={applicantrows}
            columns={applicantcolumns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            />}
        </div>
        <div className="Card">
            <p>Posted Referrals </p>
            {PostedReferrals && <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            />}
        </div>
        </div>
        </div>
    )
}

export default Profile